import { ReactNode } from "react";
import { MenuItem, SxProps, Select, SelectChangeEvent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatLabel } from "utils";
export interface MobileTabSelectProps<T> {
  options: T[];
  sx?: SxProps;
  name?: string;
  disabled?: boolean;
  value: T;
  setValue: (tab: T) => void;
}

const MobileTabSelect = <T extends string>({
  options,
  value,
  setValue,
  name,
  sx,
  disabled,
}: MobileTabSelectProps<T>): ReactNode => {
  const { t } = useTranslation();
  const handleChange = (e: SelectChangeEvent) => {
    setValue(e.target.value as T);
  };

  return (
    <Select
      fullWidth
      margin={"dense"}
      variant={"outlined"}
      id="mobile-tab-select"
      name={name}
      value={value}
      onChange={handleChange}
      disabled={disabled || !options.length}
      sx={{
        // ...sx,
        borderRadius: 0,
        "& .MuiSelect-select": {
          textAlign: "center",
          fontWeight: "bold",
        },
      }}
      MenuProps={{
        sx: {
          width: "100%",
          textAlign: "center",
          ml: -2,
          height: "calc(100dvh - 100px)",
        },
        autoFocus: false,
      }}
    >
      {options.map((option: T) => (
        <MenuItem
          key={option}
          value={option}
          disabled={disabled}
          divider
          sx={{
            textAlign: "center",
            textTransform: "capitalize",
            width: "100%",
            justifyContent: "center",
            pr: 4,
          }}
        >
          {t(`tabMenu.${option.replace(" ", "_")}`)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default MobileTabSelect;
